(() => {
  function init(root) {
    if (!root || root.__aiiInited) return;
    root.__aiiInited = true;

    const cats = Array.from(root.querySelectorAll("[data-aii-cat]"));
    const panels = Array.from(root.querySelectorAll("[data-aii-panel]"));

    if (!cats.length || !panels.length) return;

    const setActive = (catId, { focusTab = false } = {}) => {
      cats.forEach((btn) => {
        const isActive = btn.getAttribute("data-aii-cat") === catId;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-selected", isActive ? "true" : "false");
        btn.tabIndex = isActive ? 0 : -1;
        if (isActive && focusTab) btn.focus({ preventScroll: true });
      });

      panels.forEach((p) => {
        p.classList.toggle("is-active", p.getAttribute("data-aii-panel") === catId);
      });
    };

    // default
    setActive(cats[0].getAttribute("data-aii-cat"));

    // hover/focus = switch
    cats.forEach((btn) => {
      const id = btn.getAttribute("data-aii-cat");

      btn.addEventListener("mouseenter", () => setActive(id));
      btn.addEventListener("focus", () => setActive(id));
      btn.addEventListener("click", () => setActive(id, { focusTab: true }));
    });

    // keyboard arrows on tablist
    const tablist = root.querySelector(".aii-mega__catsList");
    if (tablist) {
      tablist.addEventListener("keydown", (e) => {
        const current = document.activeElement;
        const idx = cats.indexOf(current);
        if (idx === -1) return;

        let nextIdx = null;

        if (e.key === "ArrowDown") nextIdx = Math.min(idx + 1, cats.length - 1);
        if (e.key === "ArrowUp") nextIdx = Math.max(idx - 1, 0);
        if (e.key === "Home") nextIdx = 0;
        if (e.key === "End") nextIdx = cats.length - 1;

        if (nextIdx === null) return;

        e.preventDefault();
        const next = cats[nextIdx];
        setActive(next.getAttribute("data-aii-cat"), { focusTab: true });
      });
    }
  }

  const boot = () => {
    document.querySelectorAll("[data-aii-mega]").forEach(init);
  };

  document.addEventListener("DOMContentLoaded", boot);

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();

